import { z } from 'zod';

export const PrimaryAttributeSchema = z.enum(['dexterity','learning','mana','perception','strength','toughness','willpower']);

export type PrimaryAttributeType = `${z.infer<typeof PrimaryAttributeSchema>}`

export default PrimaryAttributeSchema;
